var _props, _props2, _props3, _props4, _props5, _props6, _props7, _props8, _props9, _props10, _props11;

import { IDENTIFIERS } from '../../../types/Identifiers';
import { TAG_TYPES } from '../../../types/TagTypes';
import PROPS from '../../../types/Props';
export var GROUPS_FEED = {
  tags: [{
    type: TAG_TYPES.TITLE,
    children: '{{group.name}} | {{site.name}}'
  }, {
    type: TAG_TYPES.META,
    props: (_props = {}, _props[PROPS.NAME] = 'description', _props[PROPS.CONTENT] = "{{group.description}}", _props)
  }, {
    type: TAG_TYPES.META,
    props: (_props2 = {}, _props2[PROPS.NAME] = 'robots', _props2[PROPS.CONTENT] = 'index', _props2)
  }, {
    type: TAG_TYPES.META,
    props: (_props3 = {}, _props3[PROPS.PROPERTY] = 'og:title', _props3[PROPS.CONTENT] = "{{@" + IDENTIFIERS.TITLE + "}}", _props3)
  }, {
    type: TAG_TYPES.META,
    props: (_props4 = {}, _props4[PROPS.PROPERTY] = 'og:description', _props4[PROPS.CONTENT] = "{{@" + IDENTIFIERS.DESCRIPTION + "}}", _props4)
  }, {
    type: TAG_TYPES.META,
    props: (_props5 = {}, _props5[PROPS.PROPERTY] = 'og:image', _props5[PROPS.CONTENT] = '{{group.image.url}}', _props5)
  }, {
    type: TAG_TYPES.META,
    props: (_props6 = {}, _props6[PROPS.PROPERTY] = 'og:image:width', _props6[PROPS.CONTENT] = '{{group.image.width}}', _props6)
  }, {
    type: TAG_TYPES.META,
    props: (_props7 = {}, _props7[PROPS.PROPERTY] = 'og:image:height', _props7[PROPS.CONTENT] = '{{group.image.height}}', _props7)
  }, {
    type: TAG_TYPES.META,
    props: (_props8 = {}, _props8[PROPS.PROPERTY] = 'og:site_name', _props8[PROPS.CONTENT] = '{{site.name}}', _props8)
  }, {
    type: TAG_TYPES.META,
    props: (_props9 = {}, _props9[PROPS.PROPERTY] = 'og:url', _props9[PROPS.CONTENT] = '{{group.tab.url}}', _props9)
  }, {
    type: TAG_TYPES.META,
    props: (_props10 = {}, _props10[PROPS.PROPERTY] = 'og:type', _props10[PROPS.CONTENT] = 'website', _props10)
  }, {
    type: TAG_TYPES.LINK,
    props: (_props11 = {}, _props11[PROPS.REL] = 'canonical', _props11[PROPS.HREF] = '{{group.tab.url}}', _props11)
  }]
};